import { useEffect, useState } from "react"
import { v4 as uuid } from "uuid";
import { TInnerStateCheque } from "./IInnerstate";
import ChequesList from "./list/chequesList";
import ChequeRegister from "./register/chequeRegister";
import { IFormInnerState } from "../form/IFormInnerState";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

export default function WaitCheque({ referenceKey, setStep, setFormInnerState }: IFormInnerState) {
    const [innerState, setInnerState] = useState<TInnerStateCheque>('chequeList');
    const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextInnerState) as TInnerStateCheque;
    useEffect(() => {
        if (stateFromRedux.includes('chequeList'))
            setInnerState('chequeList')
    }, [stateFromRedux])
    const innerStep = {
        'chequeList': <ChequesList setInnerState={setInnerState} setStep={setStep} referenceKey={referenceKey} />,
        'chequeRegister': <ChequeRegister setInnerState={setInnerState} setStep={setStep} referenceKey={referenceKey} />,

    }
    return (
        <div>
            {innerStep[innerState!]}
        </div>
    )
}
